module.exports = __webpack_public_path__ + "static/media/CFD.9df281fa.png";